/*
 * @Author: Vanny
 * @Date: 2019-11-13 10:47:40
 * @LastEditors: Vanny
 * @LastEditTime: 2020-03-24 15:55:05
 * @Description:
 */
export default new Map([
  ['stock_value_with_sell_price_standard', { width: 145 }],
  ['stock_value_with_purchase_price_standard', { width: 145 }],
  ['stock_value_with_purchase_price_actually', { width: 145 }],
]);
